const BANK_SEARCH_ALIASES = {
    raiffeisen: [
        'раифай', 'райф', 'райфайзен', 'раиффайзен',
        'raiff', 'raiffeisen',
    ],
    sberbank: ['сбер', 'сбербанк', 'sber'],
    tinkoff: ['т банк', 'тбанк', 'тинькофф', 'тиньков', 'tinkoff', 't bank'],
    alfabank: ['альфа', 'альфабанк', 'alfa', 'alpha bank'],
};

export function normalizeBankSearchTerm(value) {
    return String(value || '')
        .toLocaleLowerCase('ru-RU')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ё/g, 'е')
        .replace(/й/g, 'и')
        .replace(/(.)\1+/g, '$1')
        .replace(/[^a-zа-я0-9]+/g, '');
}

export function bankMatchesSearch([bankKey, label], inputValue) {
    const query = normalizeBankSearchTerm(inputValue);
    if (!query) return bankKey !== '';

    const searchValues = [bankKey, label, ...(BANK_SEARCH_ALIASES[bankKey] || [])];
    return searchValues.some((value) => normalizeBankSearchTerm(value).includes(query));
}

